var map = {
	"./Blue/0.png": 4183,
	"./Blue/1.png": 8453,
	"./Blue/10.png": 16339,
	"./Blue/11.png": 27104,
	"./Blue/12.png": 33984,
	"./Blue/13.png": 3605,
	"./Blue/14.png": 3725,
	"./Blue/15.png": 19826,
	"./Blue/2.png": 96893,
	"./Blue/3.png": 36102,
	"./Blue/4.png": 56538,
	"./Blue/5.png": 16915,
	"./Blue/6.png": 66019,
	"./Blue/7.png": 35741,
	"./Blue/8.png": 25854,
	"./Blue/9.png": 85040,
	"./Gray/0.png": 20087,
	"./Gray/1.png": 40464,
	"./Gray/10.png": 14751,
	"./Gray/11.png": 137,
	"./Gray/12.png": 43033,
	"./Gray/13.png": 75181,
	"./Gray/14.png": 89203,
	"./Gray/15.png": 65117,
	"./Gray/2.png": 45513,
	"./Gray/3.png": 10079,
	"./Gray/4.png": 50938,
	"./Gray/5.png": 24862,
	"./Gray/6.png": 12678,
	"./Gray/7.png": 99877,
	"./Gray/8.png": 91649,
	"./Gray/9.png": 18983,
	"./Green/0.png": 40363,
	"./Green/1.png": 85454,
	"./Green/10.png": 84183,
	"./Green/11.png": 7378,
	"./Green/12.png": 64674,
	"./Green/13.png": 61164,
	"./Green/14.png": 47754,
	"./Green/15.png": 31955,
	"./Green/2.png": 59891,
	"./Green/3.png": 33525,
	"./Green/4.png": 73241,
	"./Green/5.png": 25259,
	"./Green/6.png": 73734,
	"./Green/7.png": 41423,
	"./Green/8.png": 29023,
	"./Green/9.png": 38791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65892;